import { mdiEmailOutline, mdiWhatsapp } from '@mdi/js'
import { PRIVATE } from '@/plugins/acl/const'

export default [
  {
    subheader: 'communication',
    resource: PRIVATE.COMMUNICATION.MENU_HEADER,
    action: 'read',
  },
  {
    title: 'email',
    icon: mdiEmailOutline,
    to: 'communication-email-list',
    resource: PRIVATE.TEMPLATE.EMAIL,
    action: 'read',
  },
  {
    title: 'whatsapp',
    icon: mdiWhatsapp,
    to: 'communication-whatsapp',
    resource: PRIVATE.COMMUNICATION.WHATSAPP,
    action: 'read',
  },
]
